interface ErrorResponse {
    code: number;
    message: string;
}

export interface RefreshPlayerDataState {
    refreshPlayerData: any | null;
    loading: boolean;
    confirmOTPError: ErrorResponse | null;
}

export enum RefreshPlayerActionTypes {
    GET_REFRESH_PLAYER_DATA         = "GET_REFRESH_PLAYER_DATA",
    GET_REFRESH_PLAYER_DATA_SUCCESS = "GET_REFRESH_PLAYER_DATA_SUCCESS",
    GET_REFRESH_PLAYER_DATA_ERROR   = "GET_REFRESH_PLAYER_DATA_ERROR",
}

export type RefreshPlayerCreateAction =
    | { type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA }
    | { type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_SUCCESS; payload: any }
    | { type: RefreshPlayerActionTypes.GET_REFRESH_PLAYER_DATA_ERROR;   payload: ErrorResponse };